// Keeping the module export same as Retail(webPOS) for consistency.
import { BigNumber } from 'bignumber.js';

class Decimal extends BigNumber {}

export { Decimal };
